<ng-container *ngIf="!shopLayout; else shopFooter">
    <footer class="position-fixed bottom-0 w-100 z-100">
        <div class="container-xxl footer">
            <span>{{currentYear}} Well Done</span>
            <a href="mailto:support@welldone.com">Supporto</a>
        </div>
    </footer>
</ng-container>


<ng-template #shopFooter>
    <ng-container *ngIf="!isMobileDevice(); else shopMobileFooter">
        <footer class="shop-footer shop-footer-fixed">
            <div class="container-xxl footer">
                <table>
                    <tr>
                        <td>
                            <span class="text-dark">{{currentYear}} {{company.name}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="text-dark">P. IVA {{company.vat}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <a class="text-dark" [href]="company.privacyPolicyUrl" *ngIf="company.privacyPolicyUrl">Privacy Policy</a>
                            <span class="text-dark" *ngIf="company.privacyPolicyUrl "> </span>
                        </td>
                    </tr>
                </table>
                <span>{{currentYear}} Well Done</span>
                <table>
                    <tr>
                        <td class="text-right">
                            <a class="text-dark" [href]="'mailto:' + company.receivingEmail">{{company.receivingEmail}}</a>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="text-dark">{{company.address}}, {{ company.addressNumber }} - {{ company.city }} ({{company.province}})</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-right">
                            <a class="text-dark" [href]="company.cookiePolicyUrl" *ngIf="company.cookiePolicyUrl">Cookie Policy</a>
                            <span class="text-dark" *ngIf="company.cookiePolicyUrl "> </span>
                        </td>
                    </tr>
                </table>
            </div>
        </footer>
    </ng-container>
    <ng-template #shopMobileFooter>
        <footer class="shop-footer shop-footer-fixed shop-footer-mobile">
            <div *ngIf="showCompanyInfo" class="company-info">
                {{company.vat}} <br />
                {{company.address}}, {{ company.addressNumber }} - {{ company.city }} ({{company.province}}) <br />
                <a class="text-dark" [href]="company.privacyPolicyUrl" *ngIf="company.privacyPolicyUrl">Privacy Policy</a>
                <span class="text-dark" *ngIf="company.privacyPolicyUrl && company.cookiePolicyUrl"> | </span>
                <a class="text-dark" [href]="company.cookiePolicyUrl" *ngIf="company.cookiePolicyUrl">Cookie Policy</a>
            </div>
            <div class="container-xxl footer">
                <span (click)="showCompanyInfo=!showCompanyInfo">{{company.name}}</span>
                <span>{{currentYear}} Well Done</span>
                <a class="text-dark" [href]="'mailto:' + company.receivingEmail">Supporto</a>
            </div>
        </footer>
    </ng-template>
</ng-template>
